import { mergeStyleSets } from '@fluentui/react';

export const calloutStyles = mergeStyleSets({
  callout: {
    width: '325px',
    minHeight: '134px',
    height: 'fit-content',
    padding: '16px 24px 16px 24px',
    fontSize: '12px',
    '& .block-ui': {
      marginTop: '45px',
    },
    '& button': {
      color: '#ffffff',
      height: '24px',
      padding: '2px 8px 2px 8px',
      borderRadius: '4px',
      backgroundColor: '#0078d4',
    },
    '& button:hover': {
      color: '#ffffff',
      backgroundColor: '#115ea3',
    },
    '& .fui-Caption1Stronger': {
      fontWeight: '600',
    },
    '& .ms-Stack': {
      marginTop: '8px',
      marginBottom: '8px',
    },
  },
  container: {},
});

export const getPanelStyles = () => ({
  '@global': {
    '.side-panel-performance-insights.panel-right .panel-content': {
      '& .panel-body': {
        width: 915,
        paddingLeft: 24,
        paddingRight: 24,
        display: 'flex',
        height: 'calc(100% - 56px)',
        marginBottom: 0,
      },
      '& .panel-header': {
        paddingLeft: 24,
      },
      '& .panel-title': {
        fontSize: 20,
      },
      '& .react-block-ui-none, .react-block-ui': {
        display: 'flex',
        height: '100%',
      },
    },
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    marginBottom: 16,
  },
  healthCheck: {
    border: '1px solid #E6E6E6',
    borderRadius: 12,
    padding: 16,
    marginBottom: 24,
  },
  surface: {
    padding: 16,
    backgroundColor: '#FAFAFA',
    height: 'fit-content',
    minWidth: 351,
  },
  divider: {
    maxHeight: 4,
  },
  saveButton: {
    fontSize: '12px !important',
    minWidth: '68px !important',
  },
  action: {
    '& a': {
      fontSize: 12,
    },
  },
  radioGroup: {
    marginBottom: 24,
  },
  radio: {
    '& label': {
      fontSize: 12,
      fontWeight: 'normal',
    },
  },
  messageBarBody: {
    fontSize: '12px !important',
  },
  messageBarTitle: {
    fontSize: '12px !important',
    marginRight: 4,
  },
  messageBar: {
    marginBottom: 12,
  },
  title: {
    marginBottom: 16,
  },
  bottom: {
    marginTop: '16px !important',
  },
  chartTitle: {
    fontSize: '10px !important',
  },
  main: {
    width: 867,
    '& .fui-MessageBar': {
      marginBottom: 12,
    },
  },
  emptyContainer: {
    marginTop: '160px !important',
  },
});
